/**
 * Проверяет, является ли число дробным (содержит десятичную точку или не является целым).
 * @param {number|string} number - Проверяемое число.
 * @returns {boolean} true, если число дробное.
 */
function isFloat(number) {
  const regexPattern = /^-?[0-9]+$/;
  return !regexPattern.test(number);
}

export default isFloat;
